module.exports = __webpack_public_path__ + "static/img/SSDHighlightVideo_ChrisLeong_Still.a355ed8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/thumbnails/SSDHighlightVideo_ChrisLeong_Still.jpg
// module id = oLIh
// module chunks = 0